import { useLayoutEffect } from 'react';

import { Helmet } from 'react-helmet-async';

import { useOrganizationCustomization } from '../../hooks/useOrganizationCustomization';

interface OrganizationHelmetProps {
  organizationId?: number;
  defaultTitle?: string;
}

const OrganizationHelmet: React.FC<OrganizationHelmetProps> = ({
  organizationId,
  defaultTitle = 'RatioSim',
}) => {
  const { customization } = useOrganizationCustomization(organizationId);

  const title = customization?.name || defaultTitle;
  const favicon = customization?.favicon || '/favicon.png';

  useLayoutEffect(() => {
    document.title = title;
    const faviconLink = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement;
    if (faviconLink) {
      faviconLink.href = favicon;
    }
  }, [title, favicon]);

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" href={favicon} />
    </Helmet>
  );
};

export default OrganizationHelmet;
